import api from './index'

const resource = 'event_attachments'

export default {
  getEventAttachment (id) {
    return api.get(`${resource}/${id}/download_attachment`, { responseType: 'arraybuffer' })
  }
}
